module.exports = __webpack_public_path__ + "img/icon_4_44.d1cd8fc8.png";